import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import AiAgentIcon from '@atlaskit/icon/core/ai-agent';

import { Ati } from '@atlassian/ari';

import {
	INLINE_CREATE_AGENT_SKILL_TOKEN,
	useInlineCreateAgentItemClickHandler,
} from '../../CreateAgent/useInlineCreateAgentItemClickHandler.ts';
import { useInlineCreateAgentItemScreenEvent } from '../../CreateAgent/useInlineCreateAgentItemScreenEvent.ts';

import type { UseMenuItemProps, UseMenuItemReturnProps } from './index.tsx';

const CREATE_AGENT_ATI = 'ati:cloud:rovo:agent';

const messages = defineMessages({
	title: {
		id: 'create-blank-fabric-page.universal-create.inline-create-agent.title',
		defaultMessage: 'Agent',
		description:
			'Title indicating that this Universal Create option opens Rovo Chat to help create an agent.',
	},
	prompt: {
		id: 'create-blank-fabric-page.universal-create.inline-create-agent.prompt',
		defaultMessage: 'Help me build a Rovo agent {buildAgentSkill}',
		description:
			'Prompt inserted into Rovo Chat from the Universal Create Agent option. {buildAgentSkill} is the non-translated build-agent skill chip; keep it exactly once. Translate the surrounding words only.',
	},
});

const InlineCreateAgentMenuItem = ({ source }: Partial<Pick<UseMenuItemProps, 'source'>>) => {
	const { formatMessage } = useIntl();

	useInlineCreateAgentItemScreenEvent(source);

	return <>{formatMessage(messages.title)}</>;
};

export function useInlineCreateAgentItem({
	onClick,
	source,
}: UseMenuItemProps & { isMenuOpen?: boolean }): UseMenuItemReturnProps | null {
	const { formatMessage } = useIntl();

	const handleClick = useInlineCreateAgentItemClickHandler({
		onClick,
		promptText: formatMessage(messages.prompt, {
			buildAgentSkill: INLINE_CREATE_AGENT_SKILL_TOKEN,
		}),
		source,
	});

	return {
		ati: Ati.parse(CREATE_AGENT_ATI),
		children: <InlineCreateAgentMenuItem source={source} />,
		onClick: handleClick,
		elemBefore: AiAgentIcon,
		testId: 'create-menu-agent-link-item',
	};
}
